/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentsCharDataPoint
 */
export interface IncidentsCharDataPoint {
    /**
     * 
     * @type {Date}
     * @memberof IncidentsCharDataPoint
     */
    bucket: Date;
    /**
     * 
     * @type {number}
     * @memberof IncidentsCharDataPoint
     */
    incidents: number;
}

/**
 * Check if a given object implements the IncidentsCharDataPoint interface.
 */
export function instanceOfIncidentsCharDataPoint(value: object): value is IncidentsCharDataPoint {
    if (!('bucket' in value) || value['bucket'] === undefined) return false;
    if (!('incidents' in value) || value['incidents'] === undefined) return false;
    return true;
}

export function IncidentsCharDataPointFromJSON(json: any): IncidentsCharDataPoint {
    return IncidentsCharDataPointFromJSONTyped(json, false);
}

export function IncidentsCharDataPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentsCharDataPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'bucket': (new Date(json['bucket'])),
        'incidents': json['incidents'],
    };
}

export function IncidentsCharDataPointToJSON(json: any): IncidentsCharDataPoint {
    return IncidentsCharDataPointToJSONTyped(json, false);
}

export function IncidentsCharDataPointToJSONTyped(value?: IncidentsCharDataPoint | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bucket': value['bucket'].toISOString(),
        'incidents': value['incidents'],
    };
}

